"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./OverlayNotice.scss");
var _closeDarkNavy = _interopRequireDefault(require("../../images/close-dark-navy.svg"));
var _rightCaretLightGray = _interopRequireDefault(require("../../images/right-caret-light-gray.svg"));
var _useScreenSize = require("../../utils/hooks/useScreenSize");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _Button = _interopRequireDefault(require("../Button/Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const OverlayNotice = _ref => {
  let {
    header,
    button,
    details,
    handleClose,
    hasAcceptedOneTrust,
    hasDismissedOverlay,
    contentfulId
  } = _ref;
  const {
    width
  } = (0, _useScreenSize.useScreenSize)();
  const [isExpanded, setExpanded] = (0, _react.useState)(false);
  const [isClosed, setIsClosed] = (0, _react.useState)(true);
  const {
    mouse
  } = (0, _useMouse.default)();
  (0, _react.useEffect)(() => {
    if (hasAcceptedOneTrust === true && hasDismissedOverlay === true) {
      setIsClosed(true);
    } else if (hasAcceptedOneTrust === true && hasDismissedOverlay === false) {
      setIsClosed(false);
    } else if (hasAcceptedOneTrust === true) {
      setIsClosed(true);
    }
  }, [hasAcceptedOneTrust, hasDismissedOverlay]);
  const renderDetails = width > 600 || isExpanded;
  const renderExpandButton = width <= 600 && !isExpanded;
  if (hasDismissedOverlay === true) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${isClosed === false ? "overlay-notice__container overlay-notice__container--open" : "overlay-notice__container"}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, renderExpandButton && /*#__PURE__*/_react.default.createElement("button", {
    "data-sb-field-path": contentfulId ? "ctaButton" : null,
    "aria-label": `View more details about ${header}`,
    className: mouse ? `overlay-notice__button overlay-notice__button--expand` : `overlay-notice__button overlay-notice__button--expand tabFocus ${isClosed ? "overlay-notice__button--expand--closed" : ""}`,
    onClick: () => setExpanded(true)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _rightCaretLightGray.default,
    alt: "Expand Icon",
    className: "overlay-notice__caret-button-icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay-notice__grid-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay-notice__grid"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay-notice__text-content"
  }, header && /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay-notice__header",
    "data-sb-field-path": contentfulId ? "header" : null,
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
  }), details && renderDetails && /*#__PURE__*/_react.default.createElement("div", {
    className: `overlay-notice__details`,
    "data-sb-field-path": contentfulId ? "richTextDetails" : null,
    style: isExpanded || width > 600 ? {
      display: "block"
    } : {
      display: "none"
    }
  }, details)), button && renderDetails && /*#__PURE__*/_react.default.createElement("div", {
    className: `overlay-notice__cta-button`,
    style: isExpanded || width > 600 ? {
      display: "block"
    } : {
      display: "none"
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "ter-button--primary--1",
    url: button?.url,
    text: button?.text,
    contentfulId: contentfulId
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: mouse ? "overlay-notice__button overlay-notice__button--close" : "overlay-notice__button overlay-notice__button--close tabFocus",
    "aria-label": "dismiss notice",
    onClick: e => {
      setIsClosed(true);
      handleClose(e.target.value);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _closeDarkNavy.default,
    alt: "Close Icon",
    className: mouse ? "overlay-notice__close-button-icon" : "overlay-notice__close-button-icon tabFocus"
  })))));
};
var _default = OverlayNotice;
exports.default = _default;